import React, { ReactElement } from 'react';
import cn from 'classnames';
import styles from './Menus.module.scss';
import { CheckIcon } from '@components/Icons';
import DropdownMenu from './DropdownMenu';

export type Option<T> = { label: any; value: T; disabled?: boolean };

interface SelectMenuProps<T> {
  options: Array<Option<T>>;
  onChange: (optionValue: T) => void;
  value?: T;
  defaultValue?: T;
  children?: ReactElement;
  className?: string;
  menuClassName?: string;
  triggerClassName?: string;
  triggerProps?: Record<string, any>;
  expandFrom?: 'top-right' | 'bottom-left' | 'top-center' | 'top-left';
  disabled?: boolean;
  onMenuOpen?: () => void;
}

export default function SelectMenu<OptionValueType>({
  options,
  value,
  defaultValue,
  onMenuOpen,
  onChange,
  menuClassName,
  ...props
}: SelectMenuProps<OptionValueType>) {
  const selectedValue = value || defaultValue;

  const optionsWithSelected = options.map((option) => {
    const isSelected = option.value === selectedValue;
    return {
      title: option.label,
      action: () => onChange(option.value),
      disabled: option.disabled,
      suffix: isSelected ? <CheckIcon customColor="#2686be" strokeWidth={2.4} width={11} /> : null,
      className: cn(
        styles['selectMenu-option'],
        isSelected && styles['selectMenu-option-selected'],
      ),
    };
  });

  return (
    <DropdownMenu
      options={optionsWithSelected}
      menuClassName={cn(styles['selectMenu-menu'], menuClassName)}
      onOpen={onMenuOpen}
      {...props}
    />
  );
}
